// @flow
import {Field} from "redux-form";
import {FormGroup, Input, Label} from "reactstrap";
import React from "react";

/**
 * Created by Mike Chung on 2/12/18.
 */


const renderSelectField = ({
                               input,
                               label,
                               ...rest
                           }) => (
    <FormGroup>
        {label &&
            <Label for={input.id}>{label}</Label>
        }
        <Input {...input} {...rest}/>
    </FormGroup>
);
export default function ReduxFormSelectField(props: any) {

    return (
        <Field component={renderSelectField} {...props} />
    );
}


// WEBPACK FOOTER //
// ./src/components/form/ReduxFormSelectField.js